module.exports = __webpack_public_path__ + "img/au.c0084d3c.svg";